import React from "react";
import { connect } from "react-redux";

import DashboardTopNav from "../common/Topbar/BCLDashboardTopNav";
import DashboardMain from "./DashboardMain";
import CobrowsingBanner from "../common/Cobrowsing/CobrowsingBanner";
import { Configuration } from "../../configs/Configuration";
import TranslationDataFetcher from "../../dataFetchers/translationsDataFetcher";
import ConfigDataFetcher from "../../dataFetchers/configsDataFetcher";
import { fetchViewedRecos } from "../../dataFetchers/recoDataFetcher";
import { getBECompatibleLocale, prepareColorsData, replaceColorsInCss, isCobrowsingMode } from "../../helpers/helper";
import BCLLoading from '../common/Loading/BCLLoading';
import { setAndPrepareStateParam, getCleanURL } from "../../helpers/URLHelper";
import { isEmptyObject } from "../../helpers/helper";
import { enablePreview } from "../../helpers/authHelper";
import { setQueryParams} from  "../../actions/queryParamsAction";
import { fetchApplianceMapping } from '../../dataFetchers/appliancesDataFetcher';

class DashboardContainer extends React.Component {
  configuration = Configuration.getConfiguration();

  componentDidMount() {
    if(this.configuration.preview){
      enablePreview();
    }
    const {location} = this.props;
    this.props.fetchConfigData({ pilotId: this.configuration.pilotId});
    this.props.fetchColorPaletteData({ pilotId: this.configuration.pilotId});
    this.props.fetchViewedRecos(this.props.userIdentityDetails.userId);
    let queryParamsObj = setAndPrepareStateParam(location, false);
    if (Object.keys(queryParamsObj).length > 0) {
      this.props.setQueryParams(queryParamsObj);
    }

    this.props.history.push(getCleanURL(location));
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.configs.data && this.props.configs && this.props.configs.data) {
      let locale = getBECompatibleLocale(this.props.configs.data);
      this.props.fetchApplianceMapping(this.props.userIdentityDetails.userId, locale);
      this.props.fetchAllTranslations({ pilotId: this.configuration.pilotId, locale: locale});
      let faviconId = document.getElementById("favicon");
      faviconId.href = this.props.configs.data["favicon"];
    }

    if (!prevProps.configs.data || (!prevProps.configs.colorPallete) && this.props.configs.colorPallete) {
      if (this.props.configs && this.props.configs.colorPallete) {
        const COLORS_TO_REPLACE = prepareColorsData(this.props.configs.colorPallete);
        replaceColorsInCss(COLORS_TO_REPLACE);
      }
    }
  }

  render() {
    const colors = Configuration.getColors().colors;
    return (
      <>
        {this.props.configs && this.props.configs.colorPallete && this.props.configs.data && this.props.translationsData && this.props.translationsData.data && !isEmptyObject(this.props.applianceList) && !isEmptyObject(colors) ?
          <div className="dashboard-main-container">
            <DashboardTopNav logoUrl={this.props.configs.data.dashboard_logo_url} topMenuItems={this.props.configs.data["dashboard.top_menu_items"]} configs={this.props.configs}/>

            {isCobrowsingMode() && <CobrowsingBanner userObject={this.props.userObject.details} translationsData={this.props.translationsData}/>}

            <DashboardMain />
          </div> :
          <BCLLoading />
        }
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userObject: state.userObject,
    userIdentityDetails: state.userIdentityDetails,
    configs: state.configs,
    translationsData: state.translationsData,
    recommendationsData: state.recommendationsData,
    applianceList: state.appliances.appliancesList
  }
};

const mapDispatchToProps = dispatch => {
  return {
    fetchConfigData: options => dispatch(ConfigDataFetcher.fetchConfigData(options)),
    fetchAllTranslations: options => dispatch(TranslationDataFetcher.fetchAllTranslations(options)),
    fetchColorPaletteData: options => dispatch(ConfigDataFetcher.fetchColorPaletteData(options)),
    fetchViewedRecos: options => dispatch(fetchViewedRecos(options)),
    setQueryParams: queryParamsObj => dispatch(setQueryParams(queryParamsObj)),
    fetchApplianceMapping: (uuid, locale) => dispatch(fetchApplianceMapping(uuid, locale))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardContainer);
